import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: '45pswlhs',
  dataset: 'production',
  apiVersion: '2024-01-01',
  // Disable CDN to ensure fresh data (SPA with low traffic — negligible performance impact)
  useCdn: false,
  perspective: 'published',
});



